var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(_vm._b({}, "div", _vm.$attrs, false), _vm.$listeners),
    [_vm._v(_vm._s(_vm.formattedValue))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }